import { Fragment, ReactNode } from 'react'
import { Table as UITable, TableBody, TableHeader, TableRow } from '../../components/ui/table'

export interface TableColumnTemplate {
	key: string
	content: ReactNode
}

type ExtractKeyValues<T extends readonly TableColumnTemplate[]> = T[number]['key']

type TableColumnData<T extends readonly TableColumnTemplate[]> = Record<ExtractKeyValues<T>, ReactNode>

export interface TableProps<T extends readonly TableColumnTemplate[]> {
	columns: T
	data: TableColumnData<T>[]
}

export function validateTableProps<T extends readonly TableColumnTemplate[]>(columns: T, data: TableColumnData<T>[]): TableProps<T> {
	return { columns, data }
}

function Table<T extends readonly TableColumnTemplate[]>({ columns, data }: TableProps<T>) {
	return (
		<div className="overflow-hidden bg-white dark:bg-white/[0.03]">
			<div className="max-w-full overflow-x-auto custom-scrollbar">
				<div>
					<UITable>
						<TableHeader>
							<TableRow>
								{columns.map((column) => (
									<Fragment key={column.key}>{column.content}</Fragment>
								))}
							</TableRow>
						</TableHeader>
						<TableBody className="border-gray-100 dark:border-white/[0.05]">
							{data.map((row, rowIndex) => (
								<TableRow key={rowIndex + 1}>
									{columns.map((column) => (
										<Fragment key={column.key}>{row[column.key as keyof typeof row]}</Fragment>
									))}
								</TableRow>
							))}
							{data.length === 0 && (
								<TableRow>
									<td
										colSpan={columns.length}
										className="px-4 py-4 font-normal border border-gray-100 dark:border-white/[0.05] text-gray-800 text-center text-theme-sm dark:text-gray-400"
									>
										No data available
									</td>
								</TableRow>
							)}
						</TableBody>
					</UITable>
				</div>
			</div>
		</div>
	)
}

export default Table
